import { UserHistoryPathway } from "interfaces/models/UserHistoryPathway";
import { GlobalState } from "little-state-machine";

export const updateUserHistoryPathway = (state: GlobalState, userHistoryPathway: UserHistoryPathway) => ({
  ...state,
  userHistoryPathway
});
